/**
 * A half-written theory answer, kept on the device.
 *
 * A refresh, a dropped connection or the app being closed mid-answer shouldn't
 * cost a student what they wrote. Each draft is keyed by question, so one
 * question's answer never shows on another, and it's removed once the answer
 * is marked. Storage that's full or switched off simply means no draft.
 */

const PREFIX = "prepai.theory.draft.";

export const draftKey = (questionId: string) => `${PREFIX}${questionId}`;

export function readDraft(questionId: string): string {
  try {
    return localStorage.getItem(draftKey(questionId)) ?? "";
  } catch {
    return "";
  }
}

export function saveDraft(questionId: string, answer: string): void {
  try {
    if (answer) localStorage.setItem(draftKey(questionId), answer);
    else localStorage.removeItem(draftKey(questionId));
  } catch {
    /* A draft that can't be kept is still an answer on screen. */
  }
}

export function clearDraft(questionId: string): void {
  try {
    localStorage.removeItem(draftKey(questionId));
  } catch {
    /* nothing to clear */
  }
}
